import SupportCabinet from './SupportCabinet';

export default SupportCabinet;
